export * from './useNavigateToProductDetails';
